import { apolloClient } from '@/vue-apollo'
import ListSubscriptions from '@/graphql/queries/ListSubscriptions'
import GetStripeSubscriptionInfo from '@/graphql/queries/GetStripeSubscriptionInfo'

export const subscriptions = {
  namespaced: true,
  state: {
    subscriptions: [],
    loadingSubscriptions: false,
    loadingGetStripeSubscriptionInfo: false
  },
  mutations: {
    setSubscriptions (state, subscriptions) {
      state.subscriptions = subscriptions
    },
    setLoadingSubscriptions (state, loadingSubscriptions) {
      state.loadingSubscriptions = loadingSubscriptions
    },
    setLoadingGetStripeSubscriptionInfo (state, loadingGetStripeSubscriptionInfo) {
      state.loadingGetStripeSubscriptionInfo = loadingGetStripeSubscriptionInfo
    }
  },
  actions: {
    async listSubscriptions ({ commit, state, rootGetters, dispatch }) {
      try {
        commit('setLoadingSubscriptions', true)
        const res = await apolloClient.query({
          query: ListSubscriptions,
          fetchPolicy: 'no-cache'
        })
        commit('setSubscriptions', res.data.listSubscriptions)
        commit('setLoadingSubscriptions', false)
        return res.data.listSubscriptions
      } catch (e) {
        console.log(e)
        commit('setLoadingSubscriptions', false)
        commit('snackbar/showMessage', {
          content: e.message,
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async getStripeSubscriptionInfo ({ commit, state, rootGetters, dispatch }, { userId }) {
      try {
        commit('setLoadingGetStripeSubscriptionInfo', true)
        const res = await apolloClient.query({
          query: GetStripeSubscriptionInfo,
          variables: { userId },
          fetchPolicy: 'no-cache'
        })
        commit('setLoadingGetStripeSubscriptionInfo', false)
        return res.data.getStripeSubscriptionInfo
      } catch (e) {
        console.log(e)
        commit('setLoadingGetStripeSubscriptionInfo', false)
        commit('snackbar/showMessage', {
          content: e.message,
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    }
  }
}
